/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

import $ from "jquery";
document.addEventListener("DOMContentLoaded", () => {
	// console.log("Pickup Blocks – hello from the front end!");

	class ProductPreOrder {
		constructor() {
			// this.decimal_separator = okPickupsData.decimal_separator;
			// this.thousand_separator = okPickupsData.thousand_separator;
			// this.currency = okPickupsData.currency;
			this.decimal_separator = ".";
			this.thousand_separator = ",";
			this.currency = "€";

			this.createOrderForm = $("#create-order-form");

			this.vehicle_type = $("#vehicle_type");
			this.no_vehicle = $("#no_vehicle");
			this.car = $("#car");
			this.van = $("#van");
			this.from_address = $("#from_address");
			this.to_address = $("#to_address");

			this.bo_transfer_price_original = $("#bo_transfer_price_original");
			this.bo_transfer_price_final = $("#bo_transfer_price_final");
			this.bo_transfer_discount = $("#bo_transfer_discount");
			this.bo_booking_price = $("#bo_booking_price");

			this.bt_transfer_price_original = $("#bt_transfer_price_original");
			this.bt_transfer_price_final = $("#bt_transfer_price_final");
			this.bt_transfer_discount = $("#bt_transfer_discount");
			this.bt_booking_price = $("#bt_booking_price");

			this.transfer_parameters = $(".transfer_parameter");
			this.submit_button = $(".submit_btn");
			this.buy_option = $("#buy_option");
			this.no_transfer_error = $("#no_transfer_error");
			this.from_location = $("#from_location");
			this.to_location = $("#to_location");
			this.dateTypingTimer = null;
			this.dateInput = $("#date");
			// console.log("Started the class ProductCreateOrder");
			this.init();
		}

		//init
		init() {
			// console.log("init");

			//create the state
			this.state = {};

			// disable date input field before than yesterday
			const today = new Date();
			const dd = String(today.getDate()).padStart(2, "0");
			const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
			const yyyy = today.getFullYear();
			const todayString = yyyy + "-" + mm + "-" + dd;
			this.dateInput.attr("min", todayString);

			// at init wait 500ms and then load the transfer parameters to the state and manage the transfer get details

			this.addEventListeners();
		}

		//event listeners
		addEventListeners() {
			this.transfer_parameters.on("change", this.manageChange.bind(this));
			this.transfer_parameters.on("animationend", this.endAnimation.bind(this));
		}

		//methods
		loadTransferParametersToState() {
			//loop through this.transfer_parameters and add the values to the state
			this.transfer_parameters.each((index, element) => {
				// console.log(element.id + ": " + element.value);
				this.state[element.id] = element.value;
			});
			// console.log("loadTransferParametersToState");
			// console.log(this.state);
		}

		manageChange(e) {
			// console.log("manageChange");
			// add the target id and the value to the state
			this.loadTransferParametersToState();

			// check if animation is ongoing
			if (e.target.classList.contains("border-color-red")) {
				// restart the animation
				e.target.classList.remove("border-color-red");
				void e.target.offsetWidth;
			}

			// check if the element is #from_location and if value is "rome" make the #from_address visible
			if (e.target.id === "from_location") {
				if (e.target.value === "rome") {
					this.from_address.removeClass("address-invisible");
					// add the "required" attribute to the #from_address input
					this.from_address.attr("required", true);
				} else {
					this.from_address.addClass("address-invisible");
					// remove the "required" attribute to the #from_address input
					this.from_address.removeAttr("required");

					if (e.target.value === this.state["to_location"]) {
						// console.log("same value");

						// empty the to_location select input since it is equal to the from_location
						this.to_location.val("");
						// console.log(this.to_location);
						// add the class border-color-red to the target
						this.to_location.addClass("border-color-red");
					}
				}
			}

			// check if the element is #to_location and if value is "rome" make the #to_address visible
			if (e.target.id === "to_location") {
				if (e.target.value === "rome") {
					this.to_address.removeClass("address-invisible");
					// add the "required" attribute to the #to_address input
					this.to_address.attr("required", true);
				} else {
					this.to_address.addClass("address-invisible");
					// remove the "required" attribute to the #to_address input
					this.to_address.removeAttr("required");

					if (e.target.value === this.state["from_location"]) {
						// empty the from_location select input since it is equal to the to_location
						this.from_location.val("");
						// add the class border-color-red to the target
						this.from_location.addClass("border-color-red");
					}
				}
			}

			// add the class border-color-red to the target
			e.target.classList.add("border-color-red");
			// console.log(this.state);
		}

		endAnimation(e) {
			// console.log("endAnimation");
			e.target.classList.remove("border-color-red");
		}
	}

	new ProductPreOrder();
});
